export const SLACK_WORKSPACE_HOST = 'coxauto.slack.com';

export function buildSlackChannelUrl(channel) {
  return `https://${SLACK_WORKSPACE_HOST}/app_redirect?channel=${encodeURIComponent(channel.replace(/#/g, ''))}`;
}
